let localeShort: string;

export function setLocaleShort(theLocaleShort: string) {
    localeShort = theLocaleShort;
}

export function getLocaleShort(): string {
    return localeShort;
}
